<template>
  <v-card
    class="app-center"
    ref="form"
  >

    <v-toolbar
      color="light-blue lighten-1"
      cards
      dark
      flat
      height="70px">

      <v-card-title class="title font-weight-regular">{{ id ? 'Edit address' : 'Add address' }}</v-card-title>
    </v-toolbar>

    <v-card-text>
      <v-text-field
        name="first_name"
        v-model="first_name"
        label="Fisrt Name"
        hide-details
        data-vv-as="first name"
        v-validate="'required'"
        :class="{'mb-4': !errors.has('first_name')}"
      ></v-text-field>
      <div class="red--text mb-3">{{ errors.first('first_name') }}</div>

      <v-text-field
        name="surname"
        v-model="surname"
        label="Surname"
        hide-details
        v-validate="'required'"
        :class="{'mb-4': !errors.has('surname')}"
      ></v-text-field>
      <div class="red--text mb-3">{{ errors.first('surname') }}</div>

      <v-text-field
        name="address"
        v-model="address"
        label="Address Line"
        hide-details
        v-validate="'required'"
        :class="{'mb-4': !errors.has('name')}"
      ></v-text-field>
      <div class="red--text mb-3">{{ errors.first('address') }}</div>

      <v-text-field
        name="city"
        v-model="city"
        label="City"
        hide-details
        v-validate="'required'"
        :class="{'mb-4': !errors.has('city')}"
      ></v-text-field>
      <div class="red--text mb-3">{{ errors.first('city') }}</div>

      <v-text-field
        name="region"
        v-model="region"
        label="Region"
        hide-details
        class="mb-4"
      ></v-text-field>

      <v-text-field
        name="postcode"
        v-model="postcode"
        label="Postcode"
        hide-details
        v-validate="'required'"
        :class="{'mb-4': !errors.has('postcode')}"
      ></v-text-field>
      <div class="red--text mb-3">{{ errors.first('postcode') }}</div>

      <v-autocomplete
        name="country"
        :items="countries"
        v-model="country"
        label="Country"
        placeholder="Select..."
        item-text="name"
        item-value="name"
        hide-details
        v-validate="'required'"
        :class="{'mb-4': !errors.has('country')}"
      ></v-autocomplete>
      <div class="red--text mb-3">{{ errors.first('country') }}</div>

      <v-textarea
        name="input-7-1"
        v-model="note"
        label="Notes"
      ></v-textarea>

    </v-card-text>

    <v-card-actions>
      <v-btn flat router-link to="/address-book">Cancel</v-btn>
      <v-spacer></v-spacer>
      <v-btn color="primary" flat @click="submit">{{ id ? 'Edit' : 'Submit' }}</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>

import { countriesList } from '@/components/AddressBook/countries.js'

export default {
  data: () => ({
    countries: countriesList,
    first_name: null,
    surname: null,
    address: null,
    city: null,
    region: null,
    postcode: null,
    country: null,
    note: null,
    created_at: null,
    updated_at: null
  }),

  props: ['id'],

  computed: {
    form () {
      return {
        user_id: this.user.id,
        first_name: this.first_name,
        surname: this.surname,
        address: this.address,
        city: this.city,
        region: this.region,
        postcode: this.postcode,
        country: this.country,
        note: this.note,
        created_at: this.created_at,
        updated_at: this.updated_at
      }
    },
    user () {
      return this.$store.getters.user
    }
  },

  methods: {
    submit () {
      this.$validator.validate().then(result => {
        if (result) {
          if (this.id) { // we have ID so we are editing
            this.updated_at = new Date().toISOString()

            let data = this.form

            data.address_id = this.id

            this.$store.dispatch('editAddress', data)
          } else { // we don't have ID, we need to create new address
            this.created_at = new Date().toISOString()

            this.updated_at = new Date().toISOString()

            let data = this.form

            this.$store.dispatch('addAddress', data)
          }
          this.$router.push('/address-book')
        }
      })
    }
  },

  created () {
    // if we have ID, we are editing - find address to edit by ID
    if (this.id) {
      let addressBook = this.$store.getters.rawAddressBook

      console.log(addressBook)

      let address = addressBook.find((record) => {
        return record.id === this.id
      })

      this.first_name = address.first_name
      this.surname = address.surname
      this.address = address.address
      this.city = address.city
      this.region = address.region ? address.region : null
      this.postcode = address.postcode
      this.country = address.country
      this.note = address.note ? address.note : null
      this.created_at = address.created_at
      this.updated_at = address.updated_at
    }
  }
}
</script>
